module.exports = __webpack_public_path__ + "static/media/IMG_1866.89d065bb.JPG";